module.exports = __webpack_public_path__ + "img/zaixiangoutong@3x.a57b9288.svg";